<template>
  <section class="p-3">
    <div class="shadow py-3 px-6 bg-white rounded-lg">
      <h3 class="mb-2 font-semibold md:text-2xl text-lg">Post</h3>
      <section
        class="ring-1 ring-gray-200 px-4 py-3 rounded h-72 overflow-auto"
      >
        <div class="flex items-center">
          <Avatar :classStr="'h-8 w-8 mr-2'" :src="postAvatar" />
          <p class="capitalize text-xl text-gray-dark">{{ user.name }}</p>
        </div>
        <p class="text-xs mt-2 text-gray-700">
          {{ trainerPostView.body }}
        </p>
        <div class="mt-2 flex">
          <div class="flex items-center text-xs text-gray-dark">
            <div v-if="trainerPostView.is_liked" class="flex justify-center">
              <button @click="handlePostLike(trainerPostView.id)">
                <HeartFill />
              </button>
            </div>
            <div v-else class="flex justify-center">
              <button @click="handlePostLike(trainerPostView.id)">
                <Heart />
              </button>
            </div>

            <span class="ml-1">{{ trainerPostView.like_counter }} Likes</span>
          </div>
          <div v-if="comments.length > 0" class="ml-3">
            <div v-if="isCommentOpen">
              <button
                class="text-xs text-gray-dark"
                @click="isCommentOpen = !isCommentOpen"
              >
                Hide all {{ comments.length }} Comments >
              </button>
            </div>
            <div v-else>
              <button
                class="text-xs text-gray-dark"
                @click="isCommentOpen = !isCommentOpen"
              >
                View all {{ comments.length }} Comments >
              </button>
            </div>
          </div>
        </div>
        <section v-if="isCommentBoxOpen" class="mt-8">
          <div class="flex">
            <Avatar :classStr="'h-8 w-8 mr-2'" :src="postAvatar" />
            <div class="w-full">
              <div>
                <label class="block">
                  <textarea
                    class="form-textarea block w-full text-sm text-gray-light bg-gray-280"
                    rows="3"
                    :class="{ 'border-red-500mt-1': $v.body.$error }"
                    placeholder="Post your comment here..."
                    v-model="$v.body.$model"
                  ></textarea>
                </label>
                <div v-if="$v.body.$error">
                  <small class="text-red-500" v-if="!$v.body.required">
                    Description field is required.
                  </small>
                  <small class="text-red-500" v-if="!$v.body.minLength">
                    Description must have at least 10 letters.
                  </small>
                  <small class="text-red-500" v-if="!$v.body.maxLength">
                    Description must have at most 100 letters.
                  </small>
                </div>
              </div>
              <div class="mt-4 float-right">
                <button
                  class="text-green-light px-2 text-sm py-1"
                  @click="$router.go(-1);"
                >
                  Cancel
                </button>
                <button
                  class="text-white bg-green-light rounded text-sm px-2 py-1"
                  @click.prevent="handleCommentClick"
                >
                  Comment
                </button>
              </div>
            </div>
          </div>
        </section>
        <section v-if="isCommentOpen">
          <TrainerPostComments
            :data="comments"
            @replyToComment="refreshComments"
          />
        </section>
      </section>
    </div>
  </section>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { Avatar } from "@/components/t-components";
import { Heart, HeartFill } from "@/components/icons";
import { mapActions, mapGetters } from "vuex";
import TrainerPostComments from "@/components/TrainerPostComments";

export default {
  components: {
    Avatar,
    Heart,
    HeartFill,
    TrainerPostComments,
  },
  data() {
    return {
      body: "",
      isCommentBoxOpen: true,
      isCommentOpen: false,
      user: null,
      comments: [],
      postAvatar: "",
    };
  },
  validations: {
    body: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(100),
    },
  },
  computed: {
    ...mapGetters(["trainerPostView"]),
  },
  methods: {
    ...mapActions(["getTrainerPostView", "postComment", "postCommentLike"]),

    handleCommentClick() {
      this.$v.body.$touch();
      if (!this.$v.body.$invalid) {
        const data = {
          post_id: this.$route.params.id,
          body: this.body,
        };
        this.postComment(data).then(() => {
          this.body = null
          this.$v.$reset()
          this.refreshComments();
        })
      }
    },

    async handlePostLike(id) {
      const data = {
        is_liked: 1,
        post_id: id,
      };
      await this.postCommentLike(data);
      await this.getTrainerPostView(this.$route.params.id);
    },
    async refreshComments() {
      await this.getTrainerPostView(this.$route.params.id);
      this.user = this.trainerPostView.user;
      this.comments = this.trainerPostView.comments;
      this.postAvatar = this.baseUrlSrc(this.trainerPostView.thumbnail_url);
    },
  },
  async created() {
    await this.getTrainerPostView(this.$route.params.id);
    this.user = this.trainerPostView.user;
    this.comments = this.trainerPostView.comments;
    this.postAvatar = this.baseUrlSrc(this.trainerPostView.thumbnail_url);
  },
};
</script>